import React from "react";
import { Link } from "react-router-dom";
import Button from "../ui/Button";
import {
  GUIDED_TOUR_CTA_LABEL,
  GUIDED_TOUR_SIGNUP_URL,
} from "../../features/guided-tour/constants";
import { trackMetaEvent } from "../../utils/metaPixel";

const DemoPublicShell = ({ children }) => (
  <div className="h-dvh max-h-dvh overflow-hidden bg-background flex flex-col">
    <div className="shrink-0 border-b border-border bg-card px-4 py-3 sm:px-6">
      <div className="mx-auto flex max-w-[1600px] items-center justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs font-medium uppercase tracking-wide text-primary">
            Demonstração
          </p>
          <p className="truncate text-sm font-semibold text-foreground">
            neo-modelos
          </p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Button asChild variant="default" size="sm">
            <a
              href={GUIDED_TOUR_SIGNUP_URL}
              className="max-w-[11rem] truncate sm:max-w-none"
              onClick={() => {
                trackMetaEvent("ViewContent", {
                  content_name: "Conhecer Mais",
                  content_category: "demo_shell",
                });
              }}
            >
              <span className="sm:hidden">Conhecer mais</span>
              <span className="hidden sm:inline">{GUIDED_TOUR_CTA_LABEL}</span>
            </a>
          </Button>
          <Link
            to="/login"
            className="shrink-0 rounded-md border border-border px-3 py-2 text-sm font-medium text-foreground hover:bg-muted transition-colors"
          >
            Entrar
          </Link>
        </div>
      </div>
    </div>
    <div className="flex-1 min-h-0 flex flex-col overflow-hidden">
      {children}
    </div>
  </div>
);

export default DemoPublicShell;
